/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicesloadfailed2Inputs */

const en_invoicesloadfailed2 = /** @type {(inputs: Invoicesloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your invoices couldn't be loaded right now.`)
};

const de_invoicesloadfailed2 = /** @type {(inputs: Invoicesloadfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Rechnungen konnten gerade nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Your invoices couldn't be loaded right now." |
*
* @param {Invoicesloadfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicesloadfailed2 = /** @type {((inputs?: Invoicesloadfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicesloadfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicesloadfailed2(inputs)
	return de_invoicesloadfailed2(inputs)
});
export { invoicesloadfailed2 as "invoicesLoadFailed" }